var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellMobile = function SvgBellMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bellMobile_svg__a)",
    d: "M18.997 28.25v1.5h-6v-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bellMobile_svg__b)",
    d: "m21.36 2.25 3.474 4.377.163.204v10.862l3.108 7.782H3.89l3.107-7.782V6.831l.164-.204 3.474-4.377zM8.497 7.354V17.98l-.053.134-2.34 5.86H25.89l-2.34-5.86-.054-.134V7.354L20.635 3.75H11.36z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bellMobile_svg__a",
    x1: 34.356,
    x2: 13.162,
    y1: 4.452,
    y2: 27.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bellMobile_svg__b",
    x1: 34.356,
    x2: 13.162,
    y1: 4.452,
    y2: 27.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })))));
};
export { SvgBellMobile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4Ljk5NzQgMjguMjVWMjkuNzVIMTIuOTk3NFYyOC4yNUgxOC45OTc0WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzg0MTRfMjQ4NTMpIi8+CjxwYXRoIGQ9Ik0yMS4zNTk3IDIuMjVMMjQuODM0MyA2LjYyNjk1TDI0Ljk5NzQgNi44MzEwNVYxNy42OTM0TDI4LjEwNDggMjUuNDc0NkgzLjg5TDYuOTk3NDIgMTcuNjkzNFY2LjgzMTA1TDcuMTYwNTEgNi42MjY5NUwxMC42MzUxIDIuMjVIMjEuMzU5N1pNOC40OTc0MiA3LjM1MzUyVjE3Ljk4MTRMOC40NDM3MSAxOC4xMTUyTDYuMTAzODcgMjMuOTc0NkgyNS44OTFMMjMuNTUxMSAxOC4xMTUyTDIzLjQ5NzQgMTcuOTgxNFY3LjM1MzUyTDIwLjYzNTEgMy43NUgxMS4zNTk3TDguNDk3NDIgNy4zNTM1MloiIGZpbGw9InVybCgjcGFpbnQxX2xpbmVhcl84NDE0XzI0ODUzKSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzg0MTRfMjQ4NTMiIHgxPSIzNC4zNTU4IiB5MT0iNC40NTE2MiIgeDI9IjEzLjE2MiIgeTI9IjI3LjA5NjIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjEyNjMwMiIgc3RvcC1jb2xvcj0iI0ZGNzg4MCIvPgo8c3RvcCBvZmZzZXQ9IjAuMzc0NCIgc3RvcC1jb2xvcj0iIzE1Q0ZFNCIvPgo8c3RvcCBvZmZzZXQ9IjAuNjI1MTU0IiBzdG9wLWNvbG9yPSIjM0JGMkE1Ii8+CjxzdG9wIG9mZnNldD0iMC44NzYzNDgiIHN0b3AtY29sb3I9IiM2Njc1RkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyXzg0MTRfMjQ4NTMiIHgxPSIzNC4zNTU4IiB5MT0iNC40NTE2MiIgeDI9IjEzLjE2MiIgeTI9IjI3LjA5NjIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjEyNjMwMiIgc3RvcC1jb2xvcj0iI0ZGNzg4MCIvPgo8c3RvcCBvZmZzZXQ9IjAuMzc0NCIgc3RvcC1jb2xvcj0iIzE1Q0ZFNCIvPgo8c3RvcCBvZmZzZXQ9IjAuNjI1MTU0IiBzdG9wLWNvbG9yPSIjM0JGMkE1Ii8+CjxzdG9wIG9mZnNldD0iMC44NzYzNDgiIHN0b3AtY29sb3I9IiM2Njc1RkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";